module.exports = __webpack_public_path__ + "CreativeDirection4.png?a18d72651fe223f7428d5f717a344635";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CreativeDirection4.png
// module id = 52
// module chunks = 0